import studio from './studio';
import studioHome from './studio/home';
import studioPr from './studio/pr';

const studioComponentMap: any = {
  ...studio,
  ...studioHome,
  ...studioPr,
};

export default studioComponentMap;